// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"89":"8ebe10fc","362":"eba76877","453":"9fdb2cfd","633":"9e4d4849","778":"45584f37","879":"672cd880"}[chunkId] + ".chunk.js";
};